import { useMutation } from '@tanstack/react-query'
import { type Id as ToastId } from 'react-toastify'
import { bulkUpdateBFFOperations } from '../../BFF/bulkUpdates'
import { OpalApiRequestBody, OpalApiResponseDocument } from '../../schema'

type BulkUpdateResponseDocument =
  | OpalApiResponseDocument<'MomentsAddToBoardsBFFV1', 200>
  | OpalApiResponseDocument<'MomentsAddToBoardsBFFV1', 202>
type BulkUpdateRequestBody = OpalApiRequestBody<'MomentsAddToBoardsBFFV1'>

type MomentData = BulkUpdateRequestBody['data']['attributes']['moments']

export type CreateBulkUpdateParams<
  TSelectionMeta extends Record<string, unknown>,
> = {
  moments: MomentData
  /**
   * Optional argument that can be used to pass full resources and other data
   * to onMutate and onSuccess callbacks for use in things like toasts
   */
  selectionMeta?: TSelectionMeta
}

type MutationContext = { toastId?: ToastId }

type QueryParams<TSelectionMeta extends Record<string, unknown>> = {
  onMutate?: (
    params: CreateBulkUpdateParams<TSelectionMeta>
  ) => MutationContext | undefined
  onSuccess?: (
    data: BulkUpdateResponseDocument | undefined,
    params: CreateBulkUpdateParams<TSelectionMeta>,
    context?: MutationContext
  ) => void
}

export const useCreateBulkMomentsToBoardRequest = <
  TSelectionMeta extends Record<string, unknown>,
>({
  onMutate,
  onSuccess,
}: QueryParams<TSelectionMeta>) => {
  return useMutation({
    mutationFn: ({ moments }: CreateBulkUpdateParams<TSelectionMeta>) => {
      return bulkUpdateBFFOperations.momentsToBoards({
        requestBody: {
          data: {
            attributes: { moments },
            type: 'add_to_boards',
          },
        },
      })
    },
    onMutate,
    onSuccess,
  })
}
